export default __webpack_public_path__ + "static/media/entrance.68e4101d.jpeg";